/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Filter_From_DateInputs */

const en_audit_filter_from_date = /** @type {(inputs: Audit_Filter_From_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From date`)
};

const pt_br2_audit_filter_from_date = /** @type {(inputs: Audit_Filter_From_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data inicial`)
};

/**
* | output |
* | --- |
* | "From date" |
*
* @param {Audit_Filter_From_DateInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const audit_filter_from_date = /** @type {((inputs?: Audit_Filter_From_DateInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Filter_From_DateInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_filter_from_date(inputs)
	return pt_br2_audit_filter_from_date(inputs)
});